<div id="header-logo"
     class="header-logo">
    <aa-header-logo></aa-header-logo>
</div>
<div class="menu-container">
    <div class="scroll top"
         [ngClass]="{ disabled: isScrollUpDisabled }">
        <aa-scroll-menu [id]="'scrollUp'"
                        [icon]="'fa-chevron-up'"
                        (scroll)="onScrollUp()"></aa-scroll-menu>
    </div>
    <div class="menu-items-zone"
         #menuItemsZone
         (swipeup)="onScrollDown()"
         (swipedown)="onScrollUp()">
        <div class="menu-items-container"
             [style.height.px]="containerHeight"
             #menuItemsContainer>
            <aa-navbar-item *ngFor="let navbarItem of navbarItems"
                            [navbarItem]="navbarItem">
            </aa-navbar-item>
        </div>
    </div>
    <div class="scroll bottom"
         [ngClass]="{ disabled: isScrollDownDisabled }">
        <aa-scroll-menu [id]="'scrollDown'"
                        [icon]="'fa-chevron-down'"
                        (scroll)="onScrollDown()"></aa-scroll-menu>
    </div>
</div>